import Micromodal from 'micromodal';
import { ConsoleDebug } from '../../../_utils/ConsoleDebug';

export class Action {
  run() {
    this.logInstance = new ConsoleDebug('debug-modal', 'common-modal/Action');
    this.logInstance.log('run() called');
    Micromodal.init({
      openClass: 'modal--is-open',
      onShow: modal => this.onShow(modal),
      onClose: modal => this.onClose(modal),
      awaitCloseAnimation: true,
      //debugMode: true
    });
  }

  onShow (modal) {
    this.logInstance.log(`${modal.id} is shown`);
    this.closePrevModal(modal);
  }

  onClose (modal) {
    this.logInstance.log(`${modal.id} is hidden`);
  }

  closePrevModal(modal) {
    // search open MicroModal
    const openModals = document.getElementsByClassName('modal--is-open');

    // iterate open MicroModal
    Array.from(openModals).forEach((el) => {
      // close other open MicroModal with unequal id
      if ( typeof el.id === 'string' && el.id !== modal.id ) {
        this.logInstance.log(`${el.id} close via closePrevModal()`);
        Micromodal.close(el.id);
      }
    });
  }
}
